import React from "react";
import TransferList from "../../components/Transfer/TransferList/TransferList";

export type TransfersListPageProps = {
    pageName: string;
    pageTitle: string;
};

const TransferListPage: React.FC<TransfersListPageProps> = ({ pageName, pageTitle }) => {
    return <TransferList pageName={pageName} pageTitle={pageTitle} />;
};

export default TransferListPage;
